import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { deltaPercentPoints } from '../../lib/format';
import { Delta } from '../media/shared/Delta';
import { DashboardCard } from './DashboardCard';
import { SMALL_CARD_HEIGHT } from './layout';

interface MetricTileProps {
  title: string;
  tip: string;
  value: string;
  caption: string;
  delta: number | null;
  invertDelta?: boolean;
}

export function MetricTile({
  title,
  tip,
  value,
  caption,
  delta,
  invertDelta = false,
}: MetricTileProps): ReactNode {
  const deltaPoints = deltaPercentPoints(delta);
  return (
    <DashboardCard title={title} tip={tip} height={SMALL_CARD_HEIGHT}>
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography sx={{ fontSize: 24, color: 'text.primary' }}>{value}</Typography>
          {deltaPoints !== null && <Delta value={deltaPoints} invert={invertDelta} />}
        </Box>
        <Typography sx={{ color: 'text.secondary', mt: 1 }}>{caption}</Typography>
      </Box>
    </DashboardCard>
  );
}
